module.exports = __webpack_public_path__ + "img/aimPoint6.8e09b013.png";